import React from 'react';
import { Trash2, Check, RotateCcw } from 'lucide-react';
import { StatusBadge } from './StatusUI';

const ContactRow = ({ contact, onDelete, onMarkRead, onMarkProcessed, onMarkNew, formatDate }) => {
  const status = contact.status || 'nouveau';
  const isProcessed = status === 'traite';

  const handleRowClick = () => {
    if (status === 'nouveau') onMarkRead(contact.id);
  };

  return (
    <tr className={`hover:bg-gray-50 cursor-pointer ${status === 'nouveau' ? 'bg-orange-50/40' : ''}`} onClick={handleRowClick}>
      <td className="px-6 py-4 whitespace-nowrap"><StatusBadge status={status} /></td>
      <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{contact.firstName} {contact.lastName}</td>
      <td className="px-6 py-4 whitespace-nowrap">
        <a href={`mailto:${contact.email}`} onClick={(e) => e.stopPropagation()} className="text-orange-500 hover:text-orange-600">{contact.email}</a>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-gray-600">
        <a href={`tel:${contact.phone || '0600000000'}`} onClick={(e) => e.stopPropagation()} className="hover:text-orange-500">{contact.phone || '0600000000'}</a>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(contact.timestamp)}</td>
      <td className="px-6 py-4 whitespace-nowrap text-right">
        <div className="flex items-center justify-end gap-1" onClick={(e) => e.stopPropagation()}>
          {!isProcessed && (
            <button onClick={() => onMarkProcessed(contact.id)} className="text-green-600 hover:bg-green-50 p-2 rounded-lg" title="Marquer comme traité" data-testid={`mark-processed-${contact.id}`}>
              <Check className="w-4 h-4" />
            </button>
          )}
          {isProcessed && (
            <button onClick={() => onMarkNew(contact.id)} className="text-gray-500 hover:bg-gray-100 p-2 rounded-lg" title="Remettre en nouveau" data-testid={`mark-new-${contact.id}`}>
              <RotateCcw className="w-4 h-4" />
            </button>
          )}
          <button onClick={() => onDelete(contact.id)} className="text-red-500 hover:bg-red-50 p-2 rounded-lg" title="Supprimer" data-testid={`delete-contact-${contact.id}`}>
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ContactRow;
